import { Network } from "../Benefit/network";
import { PdvCycleItem } from "./pdv-cycle-item";

export class PdvFinancialStatement {
  constructor(private readonly network: Network, private readonly pdvCycleItemList: PdvCycleItem[]) {}

  public getNetwork(): Network {
    return this.network;
  }

  public getPdvCycleItemList(): PdvCycleItem[] {
    return this.pdvCycleItemList;
  }
}
